import { RequiredWorkOrderField } from '@atlas/types'

/** How each field a `fields_present` guard can require is named on screen. */
export const REQUIRED_FIELD_LABEL: Readonly<Record<RequiredWorkOrderField, string>> = {
	[RequiredWorkOrderField.ASSET_TYPE]: 'Asset type',
	[RequiredWorkOrderField.COMPLEXITY]: 'Complexity',
	[RequiredWorkOrderField.BRAND]: 'Brand',
	[RequiredWorkOrderField.MARKET]: 'Market',
	[RequiredWorkOrderField.DUE_DATE]: 'Due date',
	[RequiredWorkOrderField.PLATFORM]: 'Application platform/placement',
	[RequiredWorkOrderField.MAIN_COPY]: 'Main copy',
	[RequiredWorkOrderField.CAMPAIGN_MATERIALS]: 'Media plan',
}
